/**
 * Font loading utility functions
 */
import fontFamilyOptions from '../Components/Editor/Utils/FontFamilyOptions';
export const ensureFontLoaded = (fontFamily) => {
    return new Promise((resolve) => {
        if (!document.fonts) {
            setTimeout(resolve, 100);
            return;
        }
        if (document.fonts.check(`16px "${fontFamily}"`)) {
            resolve();
            return;
        }
        document.fonts.load(`16px "${fontFamily}"`).then(() => {
            resolve();
        }).catch(() => {
            resolve();
        });
    });
};
export const preloadFonts = () => {
    const fontFamilies = fontFamilyOptions.map(font => font.type);
    if (document.fonts) {
        fontFamilies.forEach(fontFamily => {
            document.fonts.load(`16px "${fontFamily}"`);
            document.fonts.load(`bold 16px "${fontFamily}"`);
            document.fonts.load(`italic 16px "${fontFamily}"`);
            document.fonts.load(`bold italic 16px "${fontFamily}"`);
        });
    }
};
